export const scheduling = {
  // ── 生徒側スケジュールページ (schedule/page.tsx) ──
  // ヘッダー
  title: 'レッスン希望日時を送る',
  back: 'マイページへ戻る',
  timezoneLabel: 'タイムゾーン',
  timezoneHint: '（あなたの現地時間で入力してください）',

  // 自己申請フォーム (student_driven / 個人)
  choiceLabel: '第{{n}}希望',
  required: '必須',
  optional: '任意',
  dateLabel: '日付',
  timeLabel: '時間',
  timePlaceholder: '選択',
  submit: '希望日時を送信する',
  submitting: '送信中...',
  formNote: '送信後、運営が相手方と日程を調整します。確定したらメールでご連絡します。',

  // バリデーション
  errorFirstRequired: '第1希望の日付と時間は必須です',
  errorPairBoth: '第{{n}}希望は日付と時間の両方を入力してください',
  errorCreateFailed: 'リクエストの作成に失敗しました',

  // 送信完了
  doneTitle: '送信完了！',
  doneMessage: '希望日時を受け付けました。\n運営が確認次第、Google Meetリンクをメールでお送りします。',
  toMyPage: 'マイページへ',

  // 読み込み
  loading: '読み込み中...',

  // ── manager_driven 表示 (団体が日程調整する) ──
  managerDrivenTitle: '日程は団体が調整します',
  managerDrivenMessage: '所属団体の管理者が日程を調整します。確定したらメールでご連絡しますので、しばらくお待ちください。',
  managerDrivenNote: 'ご質問がある場合は所属団体の管理者にお問い合わせください。',

  // ── 団体マネージャービュー (org/schedule/page.tsx) ──
  orgTitle: '所属メンバーの希望日時',
  orgSubtitle: '団体メンバーが送信したレッスン希望日時の一覧です。',
  orgBack: 'マイページへ戻る',
  orgMemberLabel: 'メンバー',
  orgSlotsLabel: '希望日時',
  orgStatusLabel: 'ステータス',
  orgChoice: '第{{n}}希望',
  orgEmpty: '現在、表示できる希望日時はありません。',
  orgNoAccessTitle: '希望日時を取得できませんでした',
  orgNoAccessMessage: '権限の都合でメンバーの希望日時を直接取得できない場合があります。日程確定は管理者(admin)に依頼してください。',
  orgLoadError: '読み込みに失敗しました。時間をおいて再度お試しください。',
  retry: '再読み込み',

  // ステータス表示
  statusPending: '調整待ち',
  statusConfirmed: '確定済み',
  statusOther: 'その他',
};
